import React from "react";
import { useIntl } from "react-intl";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonCardHeader,
} from "@ionic/react";
import InputItem from "../../../components/formItems/InputItem";

const PreviousVisit = (props) => {
  const { control, loading } = props;
  const intl = useIntl();
  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.previous_visit",
          })}
        </IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <InputItem
          name="previous_visit__date"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.date",
          })}
          disabled={true}
          loading={loading}
        />

        <InputItem
          name="previous_visit__duration_minutes"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.duration_minutes",
          })}
          disabled={true}
          loading={loading}
        />

        <InputItem
          name="previous_visit__planned_employee_id"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.planned_employee_id",
          })}
          disabled={true}
          loading={loading}
        />
        <InputItem
          name="previous_visit__care_giver_was_presented"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.care_giver_was_presented",
          })}
          disabled={true}
          loading={loading}
        />
      </IonCardContent>
    </IonCard>
  );
};

export default PreviousVisit;
